import { createContext, useContext } from 'react';

// Deliberately free of service imports. Every premium paygate reads usePremiumOffer, and both
// services/Mixpanel and services/UserService pull clerkConfig, which builds a Clerk client at
// module scope — importing either here drags Clerk into the import graph, and the unit tests,
// of every paygate in the app. PremiumOfferProvider owns those; this owns the contract.

export const PremiumOfferContext = createContext(null);

export const ASK_INVITE = 'invite';
export const ASK_ADMIN = 'admin';

// Whether the invite ask (share Diffit with colleagues) is live for this offer — the same
// eligibility signal every "share for premium" surface targets, from the ad campaigns'
// canAskColleaguesToShare (useAdContext) to the ?modal=shareForPremium deep link
// (PremiumOfferDeepLink). Shared so the two consumers can't drift on what "eligible" means.
export const resolveCanAskColleaguesToShare = (offered, ask) =>
  Boolean(offered) && ask === ASK_INVITE;

/**
 * `{ isOffered, ask, isInExpiryWindow, isSettled, isSettledForUser, canShareWithAdmin, hasRedeemed, offersDays, openPremiumOffer,
 * openPremiumOfferModal }`.
 *
 * Returns the inert default outside a provider rather than throwing: paygates render in
 * trees that aren't always under Base (tests, the standalone sign-in walls), and a gate
 * must not crash because the offer isn't available there.
 */
export const usePremiumOffer = () =>
  useContext(PremiumOfferContext) || {
    isOffered: false,
    ask: null,
    isInExpiryWindow: false,
    // Nothing is pending outside a provider, so a consumer that waits on this is not left
    // waiting forever.
    isSettled: true,
    canShareWithAdmin: false,
    hasRedeemed: false,
    offersDays: false,
    openPremiumOffer: () => {},
    isSettledForUser: false,
    openPremiumOfferModal: () => {},
  };
